import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=52dd2c5c&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52dd2c5c')) {
      api.createRecord('52dd2c5c', component.options)
    } else {
      api.reload('52dd2c5c', component.options)
    }
    module.hot.accept("./Image.vue?vue&type=template&id=52dd2c5c&", function () {
      api.rerender('52dd2c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/Image.vue"
export default component.exports